import React from 'react'
import { PropTypes } from 'prop-types'
import UniqId from 'uniqid'
import ShowMore from '../../common/components/show_more/show_more_component'
import { withNamespaces } from 'react-i18next'

export class HouseRule extends React.Component {
  render() {
    const { t } = this.props
    return (
      <section>
        <h2>{t('house_rule.house_rule')}</h2>
        <ul className="column2-list-wrap">
          {this.props.typical_house_rules.map((e) => {
            return(
              <li className="column2-list" key={UniqId()}>
                <dl className="column-table">
                  <dt className="column-table-title">{t(`house_rule.${e.name}`)}</dt>
                  <dd className="column-table-detail">{e.flg == true ? t('yes') : t('no')}</dd>
                </dl>
              </li>
            )
          })}
        </ul>
        {(this.props.additional_house_rule.length > 0 || this.props.additional_house_manual.length > 0) &&
          <ShowMore>{[this.props.additional_house_rule, this.props.additional_house_manual].filter(s => s).join('\n\n')}</ShowMore>
        }
      </section>
    )
  }
}

HouseRule.propTypes = {
  typical_house_rules: PropTypes.array.isRequired,
  additional_house_rule: PropTypes.string,
  additional_house_manual: PropTypes.string

}

HouseRule.defaultProps = {
  typical_house_rules: [],
  additional_house_rule: "",
  additional_house_manual: ""
}

export default withNamespaces('common')(HouseRule)
